import _ from 'lodash';
import { useSelector } from 'react-redux';

import { getBalance } from '@app/dev/helpers/balance';
import { GetBalance, GetTerminalBalance } from '../../helpers/selectors';

export const useBalance = (defaultToZero = true) => {
  const userBalance = useSelector(GetBalance);
  const terminalBalance = useSelector(GetTerminalBalance);

  return getBalance({ terminalBalance, userBalance }, defaultToZero);
};
